import { Component, OnInit, Inject, ViewChild } from "@angular/core";
import { FormGroup, FormBuilder } from "@angular/forms";
import { RxwebValidators } from "@rxweb/reactive-form-validators";
import { VngDialogRef, VNG_DIALOG_DATA, VngSelectOption } from "@vengreso/angular-components";
import { distinctUntilChanged } from "rxjs/operators";

import { ExtensionService } from "src/app/core/core-services/services/extension.service";
import { DataService } from "src/app/core/core-services/services/dataservices/data.service";
import { NotificationService } from "src/app/core/core-services/services/notification.service";
import { CategoryRenameComponent } from "../../shortcuts/add-shortcut-category/category-rename/category-rename.component";
import { CategorySelectComponent } from "../../shared/category-select/category-select.component";
import { DialogService } from "src/app/core/core-services/services/dialog.service";
import {
  ShortcutCategoryService,
  SHORTCUT_CATEGORIES,
} from "src/app/core/core-services/services/shortcut-category.service";
import { SharedDataService } from "src/app/core/core-services/services/shared-data.service";
import { DynamicStorage } from "src/app/core/core-services/decorators/dynamic-storage";

@Component({
    selector: "app-template-category-copy",
    templateUrl: "./template-category-copy.component.html",
    styleUrls: ["./template-category-copy.component.scss"],
    standalone: false
})
export class TemplateCategoryCopyComponent implements OnInit {
  public form: FormGroup;
  @DynamicStorage(SHORTCUT_CATEGORIES) shortcutCategoryList: any[];
  // R5: mat-select + the old select-search plugin -> vng-select [searchable]="true"
  // (same recipe as template-copy.component.ts / add-shortcut.component.ts).
  categoryOptions: VngSelectOption[] = [];
  @ViewChild("categorySelect") categorySelect: CategorySelectComponent;

  constructor(
    private readonly fb: FormBuilder,
    private readonly dataService: DataService,
    private readonly notification: NotificationService,
    private readonly extensionService: ExtensionService,
    @Inject(VNG_DIALOG_DATA) public data: any,
    public dialogRef: VngDialogRef<TemplateCategoryCopyComponent>,
    public dialog: DialogService,
    private readonly sharedData: SharedDataService,
    private readonly shortcutCategoryService: ShortcutCategoryService
  ) {}

  ngOnInit(): void {
    this.getShortcutCategory();

    this.form = this.fb.group({
      template_category_id: [this.data.self.categoryId],
      category_id: [null, [RxwebValidators.required()]],
    });

    this.sharedData.storage
      .observe(SHORTCUT_CATEGORIES)
      .pipe(distinctUntilChanged((prev, curr) => JSON.stringify(prev) === JSON.stringify(curr)))
      .subscribe((value) => {
        this.shortcutCategoryList = value;
        this.buildCategoryOptions();
      });

    this.buildCategoryOptions();
  }

  // R5: flatten the category tree into data-driven vng-select options once
  // per shortcutCategoryList change (same recipe as template-copy.component.ts).
  buildCategoryOptions(): void {
    const options: VngSelectOption[] = [];
    for (const cat of this.shortcutCategoryList || []) {
      options.push({ value: cat.id, label: cat.name });
      for (const sub1 of cat.sub_category_lv1 || []) {
        options.push({ value: sub1.id, label: "\u00A0\u00A0\u00A0\u00A0\u00A0" + sub1.name });
        for (const sub2 of sub1.sub_category_lv2 || []) {
          options.push({ value: sub2.id, label: "\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0" + sub2.name });
        }
      }
    }
    this.categoryOptions = options;
  }

  getShortcutCategory(reloadFromApi = false) {
    this.shortcutCategoryService.loadShortcutCategory({ reloadFromApi });
  }

  saveCategory(data) {
    this.dataService.post({ url: "v1/user/shortcut-category", data }).subscribe(
      (response: any) => {
        if (response && response.result) {
          this.extensionService.sendUpdateMessage();
          this.getShortcutCategory(true);
          this.data.self.categoryId = response.result;
          let newlyCreatedCategoryId = this.data.self?.categoryId;
          if (this.form && newlyCreatedCategoryId) {
            this.form.patchValue({ category_id: newlyCreatedCategoryId });
            this.categorySelect.closePanel();
          }
          this.notification.toast("Category added successfully!");
        }
      },
      () => {}
    );
  }

  close(): void {
    this.dialogRef.close();
  }

  copyAllCategoryTemplateToShortcut(data: any) {
    this.dataService.post({ url: "v1/user/copy-shortcut/category/single", data }).subscribe((response: any) => {
      if (response && response.result) {
        this.notification.toast("Templates added successfully.");
        this.extensionService.sendUpdateMessage();
        this.data.self.listService.getList(true);
        this.close();
      }
    });
  }

  shortcutCategoryRename(data: any) {
    this.dialog.openDialogComponent(CategoryRenameComponent, {
      self: this,
      data,
      backdropClass: "dialog-category-backdrop",
    });
  }
}
